
import "../../css/chat/chatwindow.css";
import 'react-block-ui/style.css';

import React, { Component, createRef } from 'react';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { Button, Row, Col, Form, OverlayTrigger, Tooltip } from 'react-bootstrap';
import ChatsService from '../../controllers/ChatController';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faMagnifyingGlass, faChevronUp, faChevronDown } from "@fortawesome/free-solid-svg-icons";
import { withTranslation } from "react-i18next";
import { addHistoryMessages, setSearchText, closeConversation, selectHistoryIntercation } from '../../redux/interactionsSlice';
import SendEmail from './sendemail';
import { duotone, solid } from '@fortawesome/fontawesome-svg-core/import.macro';
import Messages from './messages';
import { useNavigate } from "react-router-dom";
import Timeline from '../misc/timeline';
import LinkConfirmation from "./linkconfirmation";
import AddressBookFormCall from '../misc/AddressBookFormCall';
import MailHistory from "../misc/mailhistory";
class HistoryChatWindow extends Component {

    constructor(props) {
        super(props)

        this.state = {
            input_value: '',
            showEmojis: false,
            loading: false,
            showOutgoingChats: false,
            showInteralChat: false,
            loadingHistory: false,
            showLoadHistory: true,
            showFaq: false,
            searchText: "",
            searchTimeoutId: null,
            scrollPosition: -1,
            scrollTimeoutId: null,
            view: props && props.interaction && props.interaction.type === "MAIL" ? "mail" : "conversation",
            showTransfer: false,
            showSendEmail: false,
            showSearch: false,
            showLinkEmails: false,
            showHistory: false,
            mail: null
        }

        this.divContent = createRef();
        this.inputFile = createRef();
        this.sendButton = createRef();
        this.scrollUpRef = createRef();

        this.lastMessage = createRef();

        this.messagesRefs = [];
        this.scrollToBottom = this.scrollToBottom.bind(this);
        this.close = this.close.bind(this);
        this.showSearch = this.showSearch.bind(this);
        this.setSearchText = this.setSearchText.bind(this);
        this.toggleSendEmailModal = this.toggleSendEmailModal.bind(this);
        this.scrollToPrevious = this.scrollToPrevious.bind(this);
        this.scrollToNext = this.scrollToNext.bind(this);
        this.showSearch = this.showSearch.bind(this);
        this.addMessageRef = this.addMessageRef.bind(this);
        this.conversationClick = this.conversationClick.bind(this);
        this.conversationMailClick = this.conversationMailClick.bind(this);
        this.timelineClick = this.timelineClick.bind(this);
        this.toggleLinkEmails = this.toggleLinkEmails.bind(this);
        this.contactClick = this.contactClick.bind(this);
        this.toggleHistory = this.toggleHistory.bind(this)

    }

    componentDidUpdate = (prevProps, prevState) => {
        if (this.props.interaction !== null && (prevProps.interaction === null || (prevProps.interaction !== null && this.props.interaction.id !== prevProps.interaction.id))) {
            if (this.props.interaction.type === "MAIL") {
                this.setState({ view: "mail" });
            }
            else
                this.setState({ view: "conversation" });
        }


        if (!this.state.searchText) {
            setTimeout(() => {
                this.scrollToBottom();
            }, 500);
        }
    }


    scrollToBottom = () => {
        if (!this.state.loadingHistory && this.lastMessage.current)
            this.lastMessage.current.scrollIntoView();

    }

    setLoading(value) {
        this.setState({
            loading: value
        })
    }


    setSearchText(e) {
        e.preventDefault();

        clearTimeout(this.state.searchTimeoutId);

        let timeoutId = setTimeout(z => {
            this.props.setSearchText(e.target.value);
        }, 100);

        this.setState({
            searchTimeoutId: timeoutId,
            searchText: e.target.value,
            scrollPosition: -1
        });
    }

    scrollToPrevious(e) {
        e.preventDefault();

        if (this.state.searchText) {
            let markedMessages = this.messagesRefs.filter(x => x.current != null && x.current.innerHTML.indexOf("<mark>") > -1).map(x => x.current);
            let position = markedMessages.length - 1;

            if (markedMessages.length > 0) {

                if (this.state.scrollPosition === -1) {
                    this.setState({
                        scrollPosition: position
                    });

                } else {

                    if (this.state.scrollPosition > 0) {
                        position = this.state.scrollPosition;
                        position -= 1;
                    }
                    this.setState({
                        scrollPosition: position
                    });
                }

                markedMessages[position].scrollIntoView();

            }
        }
    }

    scrollToNext(e) {
        e.preventDefault();

        if (this.state.searchText) {
            let markedMessages = this.messagesRefs.filter(x => x.current != null && x.current.innerHTML.indexOf("<mark>") > -1).map(x => x.current);
            let position = 0;

            if (markedMessages.length > 0) {

                if (this.state.scrollPosition === (markedMessages.length - 1)) {
                    this.setState({
                        scrollPosition: position
                    });

                } else {

                    if (this.state.scrollPosition < markedMessages.length) {
                        position = this.state.scrollPosition;
                        position += 1;
                    }
                    this.setState({
                        scrollPosition: position
                    });
                }

                markedMessages[position].scrollIntoView();

            }
        }
    }


    close = e => {
        this.props.selectHistoryIntercation(null);
    }

    showSearch = e => {
        this.setState({
            showSearch: !this.state.showSearch
        });
    }

    toggleSendEmailModal = e => {
        //e.preventDefault();
        this.setState({ showSendEmail: !this.state.showSendEmail });
    }
    reopen = e => {

        ChatsService.reopenChat(this.props.interaction, res => {
            this.props.navigate("/main/interactions/chat");
        })
    }

    addMessageRef(ref) {
        this.messagesRefs.push(ref);
    }

    conversationClick(e) {
        this.setState({ view: "conversation" });
    }

    conversationMailClick(e) {
        this.setState({ view: "mail" });
    }



    timelineClick(e) {
        this.setState({ view: "timeline" });
    }

    toggleLinkEmails = e => {
        //e.preventDefault();
        this.setState({ showLinkEmails: !this.state.showLinkEmails });
    }

    contactClick(e) {
        this.setState({ view: "contact" });
    }

    toggleHistory = data => {
        this.setState({ showHistory: !this.state.showHistory, mail: { id: data.conversationId || data.id, outbound: data.outbound } });
    }
    render() {
        var url = "";

        if (this.props && this.props.interaction && this.props.interaction.type === "MAIL") {
            console.log(this.props);
            console.log(this.state);
            var ls = JSON.parse(localStorage.getItem("fc-logged"));
            var rcu = localStorage.getItem("faRCUser");
            var rcp = localStorage.getItem("faRCPwd");
            var roundcubeUrl = localStorage.getItem("faRC");
            url = `${roundcubeUrl}?user=${rcu}&pass=${rcp}&tenant=${ls.tenantName}&agentId${this.props.userId}&_task=mail&_action=show&_uid=${this.props.interaction.emailId}&_mbox=${this.props.interaction.messages[0].inbox}&_faagtinbox=1`
        }

        return (


            <>
                {
                    (this.props.interaction) &&
                    <>
                        <Row className='messages-panel postion-relative'>
                            <Col xxl={11}>
                                <Row >
                                    <Row >
                                        {
                                            (this.props.interaction.type !== "MAIL") && <Col className={
                                                "fs-4 pb-3 " +
                                                (this.state.view === "conversation" ? "border-bottom border-3 border-primary text-primary" : "cursor-pointer text-muted")
                                            } onClick={this.conversationClick} >
                                                <FontAwesomeIcon icon={duotone('messages')} /> <span className='chattab' >Conversation</span>
                                            </Col>
                                        }

                                        {
                                            (this.props.interaction.type === "MAIL") &&
                                            <Col className={
                                                "fs-4 pb-3 " +
                                                (this.state.view === "mail" ? "border-bottom border-3 border-primary text-primary" : "cursor-pointer text-muted")
                                            } onClick={this.conversationMailClick} >
                                                <FontAwesomeIcon icon={duotone('envelope')} /> <span className='emailtab' >Email</span>
                                            </Col>
                                        }

                                        {
                                            (this.props.interaction.bookId !== null) &&
                                            <Col className={
                                                "fs-4 pb-3 " +
                                                (this.state.view === "contact" ? "border-bottom border-3 border-primary text-primary" : "cursor-pointer text-muted")
                                            } onClick={this.contactClick}>
                                                <FontAwesomeIcon icon={duotone('address-book')} /> <span className='chattab'>{this.props.t("contact")}</span>
                                            </Col>
                                        }

                                        <Col className={
                                            "fs-4 pb-3 " +
                                            (this.state.view === "timeline" ? "border-bottom border-3 border-primary text-primary" : "cursor-pointer text-muted")
                                        } onClick={this.timelineClick}>
                                            <FontAwesomeIcon icon={duotone('rectangle-history-circle-user')} /> <span className='chattab'>{this.props.t("timeline")}</span>
                                        </Col>


                                    </Row>
                                </Row>
                                <Row>
                                    <Col>
                                        {
                                            (this.props.interaction && this.state.showSearch) &&
                                            <div className='search-container'>
                                                <FontAwesomeIcon className='searchiconchat' icon={faMagnifyingGlass} />
                                                <Form.Control className='searchinput' type="text" placeholder={this.props.t("search")} value={this.state.searchText} onChange={this.setSearchText} ></Form.Control>
                                                <Button ref={this.scrollUpRef} className='scroll-top' onClick={this.scrollToPrevious}>  <FontAwesomeIcon icon={faChevronUp} /></Button>
                                                <Button className='scroll-bottom' onClick={this.scrollToNext}>  <FontAwesomeIcon icon={faChevronDown} /></Button>
                                            </div>
                                        }

                                    </Col>

                                </Row>
                                <Row>
                                    {
                                        (this.state.view === "conversation") &&
                                        <Col style={{ display: (this.state.view === "conversation") ? "inline-block" : "none" }}>
                                            <Messages interaction={this.props.interaction} addMessageRef={this.addMessageRef} lastMessage={this.lastMessage} />
                                        </Col>
                                    }
                                    {
                                        (this.state.view === "mail") &&

                                        <Col style={{ display: (this.state.view === "mail") ? "inline-block" : "none" }}>
                                            <iframe src={url} width="100%" height="660px" title="historymail"></iframe>
                                        </Col>
                                    }
                                    {
                                        this.state.view === "timeline" &&
                                        <Col style={{ display: (this.state.view === "timeline") ? "inline-block" : "none" }}>
                                            <Timeline interaction={this.props.interaction} />
                                        </Col>
                                    }
                                    {
                                        this.state.view === "contact" && this.props.interaction.bookId != null &&
                                        <Col style={{ display: (this.state.view === "contact") ? "inline-block" : "none" }}>
                                            <AddressBookFormCall key={this.props.interaction.id} contacts={[{ contactId: this.props.interaction.bookId }]} />

                                        </Col>
                                    }
                                </Row>
                            </Col>
                            <Col xxl={1}>
                                <Row className='convactions-hist text-center'>
                                    <Col>
                                        <OverlayTrigger
                                            placement="left"
                                            delay={{ show: 250, hide: 400 }}
                                            overlay={<Tooltip style={{ position: "fixed" }}>
                                                {this.props.t("close")}
                                            </Tooltip>}>
                                            <Button variant="light-danger" onClick={this.close}><FontAwesomeIcon icon={solid("xmark-large")} /></Button>
                                        </OverlayTrigger>
                                        <OverlayTrigger
                                            placement="left"
                                            delay={{ show: 250, hide: 400 }}
                                            overlay={<Tooltip style={{ position: "fixed" }}>
                                                {this.props.t("search2")}
                                            </Tooltip>}>
                                            <Button variant="light-primary" onClick={this.showSearch}><FontAwesomeIcon icon={duotone("magnifying-glass")} /></Button>
                                        </OverlayTrigger>

                                        {
                                            (this.props.interaction.type !== "MAIL") &&
                                            <OverlayTrigger
                                                placement="left"
                                                delay={{ show: 250, hide: 400 }}
                                                overlay={<Tooltip style={{ position: "fixed" }}>
                                                    {this.props.t("sendemail")}
                                                </Tooltip>}>
                                                <Button variant="light-primary" onClick={this.toggleSendEmailModal}><FontAwesomeIcon icon={duotone("envelope")} /></Button>
                                            </OverlayTrigger>
                                        }

                                        {
                                            (this.props.interaction.channel === "mail" && this.props.current && this.props.current.channel === "mail") &&
                                            <OverlayTrigger
                                                placement="left"
                                                delay={{ show: 250, hide: 400 }}
                                                overlay={<Tooltip style={{ position: "fixed" }}>
                                                    {this.props.t("link")}
                                                </Tooltip>}>
                                                <Button variant="light-primary" onClick={this.toggleLinkEmails}><FontAwesomeIcon icon={duotone("link")} /></Button>
                                            </OverlayTrigger>
                                        }

                                        {
                                            this.props.interaction.channel === "mail" &&
                                            <OverlayTrigger
                                                placement="left"
                                                delay={{ show: 250, hide: 400 }}
                                                overlay={<Tooltip style={{ position: "fixed" }}>
                                                    {this.props.t("emailthread")}
                                                </Tooltip>}>
                                                <Button variant="light-primary" onClick={e => { this.toggleHistory(this.props.interaction); }}  ><FontAwesomeIcon icon={duotone("clock-rotate-left")} /></Button>
                                            </OverlayTrigger>
                                        }
                                        {
                                            (this.props.interaction.openable) &&
                                            <OverlayTrigger
                                                placement="left"
                                                delay={{ show: 250, hide: 400 }}
                                                overlay={<Tooltip style={{ position: "fixed" }}>
                                                    {this.props.t("reopen")}
                                                </Tooltip>}>
                                                <Button variant="light-primary" onClick={this.reopen}><FontAwesomeIcon icon={duotone("arrow-up-right-from-square")} /></Button>
                                            </OverlayTrigger>
                                        }
                                    </Col>
                                </Row>

                            </Col>
                        </Row>
                        <SendEmail show={this.state.showSendEmail} toggleModal={this.toggleSendEmailModal} guid={this.props.interaction != null ? this.props.interaction.guid : -1}></SendEmail>
                        <LinkConfirmation show={this.state.showLinkEmails} toggleModal={this.toggleLinkEmails}></LinkConfirmation>
                        <MailHistory show={this.state.showHistory} toggleModal={this.toggleHistory} mail={this.state.mail}></MailHistory>
                    </>
                }
                {

                    (!this.props.interaction) &&
                    <img style={{
                        "margin": "20% 0 0 30%",
                        "opacity": "0.5"
                    }} alt="Logo" src="img/f.png" className="h-50px h-lg-150px" />
                }

            </>
        );
    }

}

const mapStateToProps = (state) => {
    return {
        chatUrl: state.parameters.chatUrl,
        LOADING_TYPE: state.parameters.LOADING_TYPE,
        agentName: state.agent.name,
        interaction: state.interaction.currentHistory,
        userId: state.agent.userId,
        current: state.interaction.current
    };
};

function WithNavigate(props) {
    let navigate = useNavigate();
    return <HistoryChatWindow {...props} navigate={navigate} />
}


export default compose(connect(mapStateToProps, { addHistoryMessages, setSearchText, closeConversation, selectHistoryIntercation }), withTranslation())(WithNavigate);